// Which CTA to show on an anonymised passport view, keyed on the viewer's access to that passport:
//   - 'view-full' : the viewer already has access — the candidate (owner) or the candidate's sponsor
//     (who paid for the assessment). Link them straight to the named passport rather than hiding a
//     button. Per-viewer access grants don't exist yet (Feature 2), so "has access" is owner OR sponsor.
//   - 'request'   : a logged-in account-holder WITHOUT access — the genuine "ask the sponsor to unlock"
//     CTA.
//   - 'none'      : nothing to show — the passport is already named (not anon), OR there is no logged-in
//     viewer (the public share page has no auth; recognising a viewer there is Feature 2, so we park it).
export const getPassportCta = ({ viewerId, ownerUserId, sponsorUserId, isAnon }) => {
  if (!isAnon) return 'none';
  if (viewerId == null) return 'none';
  if (viewerId === ownerUserId || viewerId === sponsorUserId) return 'view-full';
  return 'request';
};
